module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cc-Db-Ee-Gd.6f1cf17a.png";